export default __webpack_public_path__ + "rejected-icon-light.svg";